import React from 'react';
import { publicUrl } from '../utils/publicUrl';

export default function NavIcons({ sectionId, icon, label }) {
  const go = () => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button type="button" className="navicons__btn" onClick={go} aria-label={label}>
      <img src={publicUrl(icon)} alt="" />
    </button>
  );
}
